import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import ar from './locales/ar.json';
import en from './locales/en.json';
const savedLang = (typeof window !== 'undefined' && localStorage.getItem('watad_language')) || 'ar';
export const updateHtmlDirection = (lang) => {
    if (typeof document !== 'undefined') {
        const dir = lang === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.dir = dir;
        document.documentElement.lang = lang;
        if (document.body) {
            document.body.dir = dir;
        }
    }
};
void i18next.use(initReactI18next).init({
    resources: {
        ar: { translation: ar },
        en: { translation: en },
    },
    lng: savedLang,
    fallbackLng: 'ar',
    interpolation: {
        escapeValue: false,
    },
});
// Sync direction on initial load
updateHtmlDirection(savedLang);
// Listen to language changes
i18next.on('languageChanged', (lng) => {
    if (typeof window !== 'undefined') {
        localStorage.setItem('watad_language', lng);
    }
    updateHtmlDirection(lng);
});
export const toggleLanguage = () => {
    const nextLang = i18next.language === 'ar' ? 'en' : 'ar';
    return i18next.changeLanguage(nextLang);
};
export default i18next;
//# sourceMappingURL=i18n.js.map